<template>
  <div class="tes-card pa-7">
    <h1 class="tes-card__title">{{ $t("pages.paymentsElectricity.title") }}</h1>
    <loader-wrapper :loading="loading" :showNoDataText="!providers.length" :opacity="0.8">
      <v-table-wrapper :headers="headers" :items="providers">
        <template v-slot:item.principalInfo="{ item }">
          <div class="word-wrap">{{ item.principalInfo }}</div>
        </template>
        <template v-slot:item.toPay="{ item }">
          <div class="word-wrap">{{ item.toPay || "0.00" }}</div>
        </template>
        <template v-slot:item.toPayInput="{ item }">
          <v-currency-field
            :disabled="false"
            :value="valueByPrincipal[item.principalCode]"
            outlined
            :hide-details="true"
            @input="sumChanged($event, item)"
          >
          </v-currency-field>
        </template>
      </v-table-wrapper>
    </loader-wrapper>
    <div class="payment-container mt-6">
      <span class="d-inline-block pr-3" :class="currentLocale === 'ru' ? 'helvetica-bold' : 'rubik-bold'"
        >{{ $t("pages.paymentsElectricity.total") }}:</span
      >
      <span class="d-inline-block helvetica-bold">{{ sumToPay || "0.00" }}</span>
      <span class="rub-postfix d-inline-block px-3">{{ $t("currency") }}.</span>
      <span class="pl-6">
        <v-btn
          @click="pay"
          :disabled="loading || !providers.length || !isOnline"
          class="d-inline-block orange-button mr-4"
          :class="{ 'button-font': currentLocale === 'tat' }"
          width="150"
        >
          {{ $t("buttons.pay") }}
        </v-btn>

        <!-- <v-btn
          @click="payDigitalRUB"
          :disabled="loading || !providers.length || !isOnline"
          class="d-inline-block orange-button"
          :class="{ 'button-font': currentLocale === 'tat' }"
          width="300"
        >
          Оплатить цифровым рублем
        </v-btn> -->
      </span>
    </div>
    <div class="payment-container">
      <span class="d-inline-block pr-3" :class="currentLocale === 'ru' ? 'helvetica-italic' : 'rubik-italic'">{{
        $t("pages.paymentsElectricity.commission")
      }}</span>
    </div>

    <modal-payment :toPay="sumToPay" :details="payDetails" v-model="showModalPayment" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import VTableWrapper from "../../../components/wrapper/VTableWrapper";
import VCurrencyField from "../../../components/common/VCurrencyField";
import ModalPayment from "../../../components/modals/ModalPayment";
import LoaderWrapper from "../../../components/common/LoaderWrapper";
import { AxiosWrapper } from "../../../assets/api/AxiosWrapper";

export default {
  components: {
    VTableWrapper,
    VCurrencyField,
    ModalPayment,
    LoaderWrapper
  },
  layout: "main",
  data: () => ({
    valueByPrincipal: {},
    loading: false,
    showModalPayment: false,
    windowSize: {
      x: 0,
      y: 0
    }
  }),
  mounted() {
    this.onResize();
  },
  computed: {
    sumToPay() {
      let sum = 0;
      for (let [key, value] of Object.entries(this.valueByPrincipal)) {
        sum = (sum * 100 + value * 100) / 100;
      }
      return parseFloat(sum.toFixed(2));
    },
    payDetails() {
      let details = [];
      for (let [key, value] of Object.entries(this.valueByPrincipal)) {
        details.push({
          principalCode: key,
          toPay: value
        });
      }
      return details;
    },
    headers() {
      return [
        {
          text: this.$t("pages.paymentsElectricity.code"),
          value: "principalCode",
          isResizable: true
        },
        {
          text: this.$t("pages.paymentsElectricity.orgName"),
          value: "principalName",
          isResizable: true
        },
        {
          text: this.$t("pages.paymentsElectricity.contractDetails"),
          value: "principalInfo",
          isResizable: true
        },
        {
          text: this.$t("pages.paymentsElectricity.sumEpd"),
          value: "toPay",
          isResizable: true
        },
        {
          text: this.$t("pages.paymentsElectricity.sumPay"),
          value: "toPayInput",
          isResizable: false
        }
      ];
    },
    ...mapState("account", ["selectedAccount"]),
    ...mapState("payments", ["providers", "currentReceipt"]),
    ...mapState("common", ["isOnline"]),
    ...mapGetters("locale", ["currentLocale"])
  },
  watch: {
    selectedAccount: {
      immediate: true,
      handler: function(value) {
        this.loading = true;
        this.$store.dispatch("payments/getCurrentReceipt", {
          domHoz: value.domHoz
        });
      }
    },
    currentReceipt() {
      this.doGetReceiptDetails();
    },
    isOnline(value) {
      if (value) {
        this.doGetReceiptDetails();
      }
    }
  },
  methods: {
    doGetReceiptDetails() {
      this.loading = true;
      this.$store
        .dispatch("payments/getReceiptDetails", {
          domHoz: this.selectedAccount.domHoz,
          year: this.currentReceipt.year,
          month: this.currentReceipt.month
        })
        .then(() => {
          this.valueByPrincipal = {};
          this.providers.map(el => {
            this.$set(this.valueByPrincipal, el.principalCode, el.toPay);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pay() {
      if (this.sumToPay <= 0) {
        this.$store.commit("common/ADD_ALERT", {
          text: this.$t("pages.paymentsElectricity.positiveNumber"),
          type: "error"
        });
      } else {
        this.showModalPayment = true;
      }
    },
    // payDigitalRUB() {
    //   console.log("Начала оплаты");

    //   if (this.sumToPay <= 0) {
    //     this.$store.commit("common/ADD_ALERT", {
    //       text: this.$t("pages.paymentsElectricity.positiveNumber"),
    //       type: "error"
    //     });
    //   }

    //   AxiosWrapper.post("PayDigitRUB");
    // },
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight
      };
    },
    sumChanged(val, item) {
      this.$set(this.valueByPrincipal, item.principalCode, Number(val));
    }
  }
};
</script>

<style lang="scss" scoped>
.word-wrap {
  width: 100%;
  display: block;
  white-space: normal;
  padding: 10px 0;
}

.payment-container {
  margin-top: 10px;
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
}

.button-font {
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>
